export default class Locale_ForwardRequestDialog { 
	FailedCreatingForwardRequest: string = "Failed creating forward request view";
	ForwardRequestTitle: string = "Forward request";
	ForwardRequestSubtext: string = "Use the grid to select how much of the request to forward at the given time range. Forwarding requests to other resources is done within the same time span as the original request, e.g. if a request is made in May, you can only forward the request to a different resource in May.";
	ForwardEverything: string = "Autofill all";
}